import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { cartTrack } from '../../analytics/tracker/events/cartEvents';
import '../../css/footer.css';
import { cart } from '../../paths/defaultImage';
import {
  getOrderType,
  getOrderTypeSession,
  getSessionKey,
  orderTypeRetrival,
} from '../../webStorage/manageOrderType';
import { setPreviousPath } from '../../webStorage/sessionStorage';
import { getItemsByProperty } from '../menu/Functions/getItemsByProperty';
import queryString from 'query-string';
import { useCookies } from 'react-cookie';
import { orderTypeTrack } from '../../analytics/tracker/events/orderTypeEvents';
import { rcsTrack } from '../../functions/rcsTrack';
import { getLocalItem, removeLocalItem } from '../../webStorage/localStorage';
import { getCartTokenLS } from '../../functions/getCartToken';
import LazyImage from '../common/lazyLoad';

const MenuPageFooter = () => {
  const { t } = useTranslation();
  const sendToCart = getLocalItem('sendToCart');
  const urlQuery = queryString.parse(window.location.search);
  const [cookies] = useCookies([]);
  const cartFromRedux = useSelector((state) => state.cart.cart);
  const { url } = useRouteMatch();
  const params = useParams();
  const restarantNameIdFromRedux = useSelector((state) => state.restSetting?.Setting.nameid);
  const restarantIdFromRedux = useSelector((state) => state.restSetting?.Setting.id);
  const sessionSetting = getOrderTypeSession();
  const userDetails = useSelector((state) => state.userDetails?.Details?.data);
  const history = useHistory();
  // const cartTokenFromLS = getCartTokenLS();
  const totalCartQuantity =
    (cartFromRedux &&
      Array.isArray(cartFromRedux?.cart_items) &&
      cartFromRedux.cart_items.reduce((total, elem) => elem.quantity + total, 0)) ||
    0;

  useEffect(() => {
    if (sendToCart) {
      removeLocalItem('sendToCart');
      clickHandler();
    }
  }, [sendToCart]);

  const clickHandler = () => {
    const cartTokenFromLS = getCartTokenLS();
    if (cartFromRedux?.cart_items?.length > 0) {
      const algoCartItemsIdsTrackString = cartFromRedux?.cart_items
        ?.map((item) => item.item_id)
        .join('|');
      rcsTrack('cartPage', { itemId: algoCartItemsIdsTrackString });
    }
    const ot = getOrderType();
    const setting = getOrderTypeSession();
    const validateOrderTypes = ['0', '1', '2', 0, 1, 2];
    if (!ot || !validateOrderTypes.includes(setting?.orderType)) {
      if (params?.ot) {
        orderTypeRetrival(params, cookies, urlQuery);
        orderTypeTrack(
          cartTokenFromLS,
          'Menu page',
          `${getOrderTypeSession()} , ${getSessionKey()}`,
          '',
          '',
          '',
          'tried to set order type',
          ''
        );
      } else {
        // setShowOrderTypePopup(true); // this not working ! popup does not opens up ?
        orderTypeTrack(
          cartTokenFromLS,
          'Menu page',
          `${getOrderTypeSession()} , ${getSessionKey()}`,
          '',
          '',
          '',
          'failed to set order type',
          ''
        );
      }
    }

    cartTrack({
      Cart_Size: cartFromRedux?.cart_items?.length,
      Cart_Item_IDs: getItemsByProperty(cartFromRedux?.cart_items, 'cart_item_id'),
      Cart_Item_Names: getItemsByProperty(cartFromRedux?.cart_items, 'item_name'),
      Item_Total: cartFromRedux?.total_amount,
      Total_Discount: cartFromRedux?.total_savings,
      Tax_Amount: cartFromRedux?.tax,
      Estimated_Total_Amount: cartFromRedux?.total_after_tax,
      User_ID: userDetails?.phone,
      Restaurant_ID: restarantIdFromRedux,
      USER_SIGNED_IN: !!userDetails?.token,
      Order_Type_ID: sessionSetting?.orderType,
      cart_token: cartTokenFromLS,
    });
    if (params?.ot && params?.ot != 'undefined') {
      history.push(
        `/cart/${restarantNameIdFromRedux}/${params?.ot}${params.pickupType ? '/ta' : ''}`
      );
    } else {
      history.push(`/cart/${restarantNameIdFromRedux}`);
    }
    setPreviousPath(url);
  };

  return (
    <>
      {totalCartQuantity > 0 && cartFromRedux.current_restaurant_id === restarantIdFromRedux ? (
        <div className='d-flex view-cart-cta flex-column gap-2'>
          <div id='cartFooter' className='cartFooterDetail primary pointer' onClick={clickHandler}>
            <div className='d-flex justify-content-center align-items-center viewCart'>
              <div className='d-flex justify-content-between align-items-center gap-3'>
                <div className='cart-icon'>
                  <LazyImage src={cart} width={21} height={19} alt='cart' />
                  <div className='item-quantity d-flex justify-content-center align-items-center fw-500 fs-12'>
                    {totalCartQuantity}
                  </div>
                </div>
                <div className='fs-16 fw-400 text-white'>{t('button_view_cart')}</div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default MenuPageFooter;
